module.exports = __webpack_public_path__ + "static/media/MIFA1.c80f137b.jpg";